export abstract class Functions{
    static getBase64(file:File) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      }
}


// WEBPACK FOOTER //
// ./src/utils/funtions.ts